import React from "react";
import { Column, Table } from "stories/Admin";
import styles from "./NotificationList.module.scss";

interface Notification {
  id: number;
  title: string;
  body: string;
  date: string;
}

interface NotificationListProps {
  notifications: Notification[];
}

const pad = (n: number) => String(n).padStart(2, "0");

/** «10.10.2026 18:02» */
const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return dateString;
  return `${pad(date.getDate())}.${pad(
    date.getMonth() + 1,
  )}.${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
};

const columns: Array<Column<Notification>> = [
  {
    key: "title",
    header: "Tittel",
    render: (n) => <b>{n.title}</b>,
  },
  {
    key: "body",
    header: "Melding",
    render: (n) => <span className={styles.body}>{n.body}</span>,
  },
  {
    key: "date",
    header: "Sendt",
    width: 150,
    numeric: true,
    render: (n) => <span className={styles.date}>{formatDate(n.date)}</span>,
  },
];

const NotificationList: React.FC<NotificationListProps> = ({
  notifications,
}) => (
  <Table
    columns={columns}
    rows={notifications}
    rowKey={(n) => n.id}
    caption="Sendte push-meldinger"
  />
);

export default NotificationList;
